import { render, staticRenderFns } from "./ArticleDepartmentItem.vue?vue&type=template&id=e95e3dd8&scoped=true"
import script from "./ArticleDepartmentItem.vue?vue&type=script&lang=js"
export * from "./ArticleDepartmentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95e3dd8",
  null
  
)

export default component.exports